import useSWR from 'swr';
import letrusAPI from 'APIs/letrusAPI/axiosInstance';
import {ActivitiesByStatus} from './types';

export function fetchActivitiesRequest() {
  return useSWR<ActivitiesByStatus>(
    '/api/v1/activities/',
    (url) => letrusAPI(url).then((response) => response.data),
    {shouldRetryOnError: false, revalidateOnFocus: false, dedupingInterval: 0},
  );
}
